// User Constants
export const USER_URL = `/api/user`
export const ALL_USERS = `${USER_URL}/all_users`
export const ALL_USERS_LIST = `${USER_URL}/all_users_list`
export const DELETED_USERS = `${USER_URL}/deleted`
export const RESTORE_USER = (id) => `${USER_URL}/restore/${id}`
export const GET_USER = (id) => `${USER_URL}/${id}`
export const CREATE_USER = `${USER_URL}/create_user`
export const BREAK_DOWN = `${USER_URL}/breakdown`
export const UPDATE_PENDING_USER = `${USER_URL}/update_pending_user`
export const ABOUT_ME_URL = `${USER_URL}/aboutme`
export const UPDATE_ME_URL = `${USER_URL}/updateme`
export const SAVE_SETTINGS = `${USER_URL}/save_settings`
export const DOWNLOAD_USER_DATA = `${USER_URL}/download_data`
export const UPLOAD_USER_DATA = `${USER_URL}/upload_data`

